import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { AiModelFamiliesFetchedAction } from '@Application/Ai/AiModelFamilies/Actions/aiModelFamiliesFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AiModelFamiliesStore = {
	aiModelFamilies: readonly LabeledValueView[] | null;
};

const initialState: AiModelFamiliesStore = {
	aiModelFamilies: null,
};

type Actions = AiModelFamiliesFetchedAction | UserRevokedAction;

const whenAiModelFamiliesFetched = (
	store: AiModelFamiliesStore,
	action: AiModelFamiliesFetchedAction,
): AiModelFamiliesStore => ({
	...store,
	aiModelFamilies: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): AiModelFamiliesStore => initialState;

export default registerStore<'aiModelFamiliesStore', Actions>(
	'aiModelFamiliesStore',
	createSliceReducer({
		AI_MODEL_FAMILIES_FETCHED: whenAiModelFamiliesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
